<template>
  <section class="section-padding-home">
    <div class="row">
      <div class="col-lg-6 col-12">
        <h3 class="home-title">
          {{ $t('message.home.recommend_in') }}{{ globalState.cities[provinceId] | multiLangName }}
        </h3>
      </div>
      <div class="col-lg-6 col-12 text-right" v-if="!$mq.phone">
        <router-link :to="'/recommend/'+provinceId"
                     tag="a"
                     class="text-primary-link">
          {{ $t('message.see_all') }} <i class="far fa-angle-right"></i>
        </router-link>
      </div>
    </div>
    <section v-if="recommendProfessionals">
      <div class="row mt-2">
        <div class="col-lg-3 col-6 pb-3 col-recommend-professional px-2" v-for="professional in recommendProfessionals">
          <recommend-professional :professional="professional"/>
        </div>
      </div>
      <div class="row mt-4" v-if="$mq.phone">
        <div class="col-12">
          <router-link :to="'/recommend/'+provinceId" class="button button-large button-outline button-block">
            {{ $t('message.see_all') }}
          </router-link>
        </div>
      </div>
    </section>
    <div v-else>
      <loader/>
    </div>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex'
  import loader from '../loader/Loader'
  import recommendProfessional from '../recommend/components/RecommendProfessional'

  export default {
    props: ['provinceId'],
    components: {
      loader,
      recommendProfessional
    },
    computed: {
      ...mapGetters({
        globalState: 'globalVal/getState'
      })
    },
    data () {
      return {
        recommendProfessionals: null
      }
    },
    methods: {
      fetchRecommendProfessionals (provinceId) {
        const queryData = {
          province_id: provinceId,
          limit: 8
        }

        const url = this.$http.options.root + '/bookings/recommend-professionals'
        this.$http.get(url, {params: queryData})
          .then(response => {
            return response.json()
          })
          .then(response => {
            if (!response.error) {
              this.recommendProfessionals = response.professionals
            }
          })
      }
    },
    mounted () {
      this.fetchRecommendProfessionals(this.provinceId)
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/home/RecommendProfessionals.vue